export default "__VITE_ASSET__CqX3eRAN__"